/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyWalletAmountQueryVariables = Types.Exact<{
  platform: Types.Platform;
}>;

export type LoyaltyWalletAmountQuery = {
  __typename?: 'Query';
  loyaltyWallet?: { __typename?: 'LoyaltyWallet'; amount: number };
};

export const LoyaltyWalletAmountDocument = /*#__PURE__*/ `
    query LoyaltyWalletAmount($platform: Platform!) {
  loyaltyWallet(platform: $platform) {
    amount
  }
}
    `;

export function useLoyaltyWalletAmountQuery(
  options: Omit<Urql.UseQueryArgs<LoyaltyWalletAmountQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    LoyaltyWalletAmountQuery,
    LoyaltyWalletAmountQueryVariables
  >({ query: LoyaltyWalletAmountDocument, ...options });
}
